"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROBLEM_TEXT = exports.FIELD_KEYS = exports.BLINK_FIELDS = void 0;
exports.canMerge = canMerge;
exports.oneColumnProblems = oneColumnProblems;
exports.normalizeHeader = normalizeHeader;
exports.suggestMapping = suggestMapping;
exports.refreshLayout = refreshLayout;
exports.missingColumns = missingColumns;
exports.parsePin = parsePin;
exports.pinInUae = pinInUae;
exports.parseMoneyToFils = parseMoneyToFils;
exports.parseRow = parseRow;
exports.merchantKey = merchantKey;
exports.merchantCode = merchantCode;
exports.pieceLabels = pieceLabels;
// Reading client files (plan 4.2): column layouts, value cleaning and row checks.
// Pure functions — the API adds the checks that need the database (duplicate AWB in
// the system, district lookup).
const phone_1 = require("./phone");
exports.BLINK_FIELDS = [
    { key: 'awb', label: 'AWB number', required: true, synonyms: ['awb', 'awb no', 'awb number', 'awb id', 'tracking id', 'waybill', 'waybill no', 'waybill number', 'tracking', 'tracking no', 'tracking number', 'shipment no', 'shipment number', 'consignment no', 'consignment number', 'hawb'] },
    { key: 'merchantReference', label: 'Merchant reference', synonyms: ['order ref', 'order reference', 'order no', 'order number', 'order id', 'reference', 'ref', 'merchant ref', 'merchant reference', 'client ref', 'client reference', 'reference number', 'reference no'] },
    { key: 'merchant', label: 'Merchant', synonyms: ['merchant', 'merchants', 'merchant name', 'merchant company', 'shipper', 'shipper name', 'seller', 'seller name', 'vendor', 'vendor name', 'store', 'store name', 'client', 'client name', 'brand', 'sender', 'sender name', 'consignor', 'consignor name'] },
    { key: 'consigneeName', label: 'Customer name', required: true, multi: true, synonyms: ['receiver name', 'consignee name', 'recipient name', 'receiver', 'consignee', 'recipient', 'customer name', 'customer', 'name', 'contact name'] },
    { key: 'phone', label: 'Mobile', required: true, synonyms: ['receiver phone', 'receiver mobile', 'consignee phone', 'consignee mobile', 'recipient phone', 'recipient mobile', 'mobile', 'mobile no', 'mobile number', 'phone', 'phone no', 'phone number', 'contact', 'contact no', 'contact number', 'tel', 'telephone', 'customer phone', 'customer mobile', 'msisdn'] },
    { key: 'altPhone', label: 'Alternate mobile', synonyms: ['alt phone', 'alternate phone', 'alternate mobile', 'alternative phone', 'phone 2', 'mobile 2', 'second phone', 'other phone'] },
    { key: 'address', label: 'Address', required: true, multi: true, synonyms: ['address', 'addr', 'address 1', 'address1', 'address line 1', 'addr1', 'addr 1', 'street', 'full address', 'delivery address', 'consignee address', 'receiver address'] },
    { key: 'city', label: 'City / emirate', synonyms: ['city', 'emirate', 'town', 'state'] },
    { key: 'district', label: 'District / area', multi: true, synonyms: ['district', 'area', 'locality', 'zone', 'community', 'address line 2', 'address 2', 'address2', 'addr2', 'addr 2', 'neighbourhood', 'neighborhood'] },
    { key: 'latitude', label: 'Latitude', synonyms: ['lat', 'latitude', 'pin lat', 'gps lat'] },
    { key: 'longitude', label: 'Longitude', synonyms: ['lng', 'lon', 'long', 'longitude', 'pin lng', 'gps lng'] },
    { key: 'pin', label: 'Pin (lat,lng or map link)', synonyms: ['pin', 'location', 'gps', 'coordinates', 'lat long', 'latlng', 'lat lng', 'geo', 'map link', 'location link'] },
    { key: 'cod', label: 'COD amount (AED)', synonyms: ['cod', 'cod amount', 'cod amt', 'cod value', 'cash on delivery', 'amount to collect', 'collect amount', 'cod aed', 'cod amount aed'] },
    { key: 'pieces', label: 'Pieces', synonyms: ['pcs', 'pieces', 'no of pieces', 'number of pieces', 'piece count', 'packages', 'boxes', 'parcels', 'qty pieces', 'package count', 'packages count', 'no of packages', 'number of packages', 'total pieces', 'total packages'] },
    { key: 'weight', label: 'Weight (kg)', synonyms: ['weight', 'weight kg', 'wt', 'gross weight', 'actual weight', 'weight in kg'] },
    { key: 'deliveryType', label: 'Delivery type', synonyms: ['service', 'service type', 'delivery type', 'product', 'service level'] },
    { key: 'timeSlot', label: 'Time slot', synonyms: ['slot', 'time slot', 'delivery slot', 'delivery time', 'preferred time'] },
    { key: 'description', label: 'Contents', multi: true, synonyms: ['description', 'content', 'contents', 'item', 'items', 'goods', 'item description'] },
    { key: 'clientStatus', label: 'Status in client file', synonyms: ['status', 'shipment status', 'current status', 'order status', 'awb status'] },
];
exports.FIELD_KEYS = exports.BLINK_FIELDS.map((f) => f.key);
/**
 * Text fields may join several file columns (Address line 1 + line 2). Every other field
 * takes ONE column: joining two amounts ("COD Amount" + "Declared Value") gives a wrong number.
 */
function canMerge(key) {
    const f = exports.BLINK_FIELDS.find((x) => x.key === key);
    return !!f && 'multi' in f && f.multi === true;
}
/** Fields that have more than one column but may take only one. */
function oneColumnProblems(def) {
    return Object.entries(def.fields).filter(([k, cols]) => (cols?.length ?? 0) > 1 && !canMerge(k)).map(([k]) => k);
}
function normalizeHeader(header) {
    return header
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}
// Client exports often describe both ends ("Origin City", "Destination City", "Shipper Phone").
// Customer fields come from the receiving end; the sending end only names the merchant.
const SENDER_SIDE = /\b(origin|shipper|sender|seller|pickup|consignor|return|rto|from)\b/;
const RECEIVER_SIDE = /\b(destination|receiver|consignee|customer|recipient|delivery|dest)\b/;
/** Proposes a layout from the column names when the project has none for this file yet. */
function suggestMapping(headers) {
    const fields = {};
    const taken = new Set();
    // receiving-end columns first, so "Destination City" wins over a plain "City" further on
    const ordered = [...headers].sort((a, b) => Number(RECEIVER_SIDE.test(normalizeHeader(b))) - Number(RECEIVER_SIDE.test(normalizeHeader(a))));
    // exact names first, then names that contain a synonym
    for (const pass of ['exact', 'contains']) {
        for (const f of exports.BLINK_FIELDS) {
            if (fields[f.key]?.length && f.key !== 'address')
                continue;
            const synonyms = f.synonyms;
            // exact: the column matching the earliest synonym wins ("Merchants" before "Shipper Name")
            // contains: receiving end first, then the earliest synonym ("Destination District" before "Destination Zone")
            const containsRank = (h) => {
                const n = normalizeHeader(h);
                const i = synonyms.findIndex((s) => s.length > 3 && n.includes(s));
                return (RECEIVER_SIDE.test(n) ? 0 : 1000) + (i < 0 ? 999 : i);
            };
            const candidates = f.key === 'address'
                ? pass === 'exact'
                    ? headers
                    : ordered
                : pass === 'exact'
                    ? headers
                        .filter((h) => synonyms.includes(normalizeHeader(h)))
                        .sort((a, b) => synonyms.indexOf(normalizeHeader(a)) - synonyms.indexOf(normalizeHeader(b)))
                    : [...headers].sort((a, b) => containsRank(a) - containsRank(b));
            for (const h of candidates) {
                if (taken.has(h))
                    continue;
                const n = normalizeHeader(h);
                if (f.key !== 'merchant' && SENDER_SIDE.test(n))
                    continue;
                const hit = pass === 'exact' ? synonyms.includes(n) : synonyms.some((s) => s.length > 3 && n.includes(s));
                if (hit) {
                    fields[f.key] = [...(fields[f.key] ?? []), h];
                    taken.add(h);
                    if (f.key !== 'address')
                        break;
                }
            }
        }
    }
    return { fields, statusFilter: null, weightUnit: 'KG' };
}
/** Customer-side fields: never read from the sending end of a two-sided export. */
const RECEIVER_FIELDS = ['consigneeName', 'phone', 'altPhone', 'address', 'city', 'district', 'latitude', 'longitude', 'pin'];
/** Fields added to a saved layout that lacks them (they were learned after it was saved). */
const ADD_WHEN_MISSING = ['merchant', 'pieces', 'awb', 'phone', 'consigneeName', 'address', 'district'];
/**
 * A saved layout brought up to date for this file (D-0012): sending-end columns are
 * taken out of customer fields, and a merchant, pieces or required column the layout
 * never had is added from the suggestion. Returns the fields that changed.
 */
function refreshLayout(saved, headers) {
    const suggestion = suggestMapping(headers);
    const fields = Object.fromEntries(Object.entries(saved.fields).map(([k, v]) => [k, [...(v ?? [])]]));
    const updated = new Set();
    // a layout saved before the one-column rule: keep the first column only
    for (const k of oneColumnProblems(saved)) {
        fields[k] = fields[k].slice(0, 1);
        updated.add(k);
    }
    const senderOnly = (c) => SENDER_SIDE.test(normalizeHeader(c)) && !RECEIVER_SIDE.test(normalizeHeader(c));
    for (const k of RECEIVER_FIELDS) {
        const cols = fields[k];
        if (!cols?.length)
            continue;
        const kept = cols.filter((c) => !senderOnly(c));
        if (kept.length === cols.length)
            continue;
        updated.add(k);
        if (kept.length)
            fields[k] = kept;
        else
            delete fields[k];
    }
    const used = () => new Set(Object.values(fields).flat());
    // a customer field emptied above is refilled from the receiving end
    for (const k of new Set([...ADD_WHEN_MISSING, ...updated])) {
        if (fields[k]?.length)
            continue;
        if (k === 'merchant' && saved.merchantId)
            continue; // one merchant chosen for the whole file on purpose
        const cols = (suggestion.fields[k] ?? []).filter((c) => !used().has(c));
        if (!cols.length)
            continue;
        fields[k] = cols;
        updated.add(k);
    }
    return { definition: { ...saved, fields, merchantId: fields.merchant?.length ? null : (saved.merchantId ?? null) }, updated: [...updated] };
}
/** Columns a saved layout needs that the new file does not have (the client changed its file). */
function missingColumns(def, headers) {
    const have = new Set(headers);
    return [...new Set(Object.values(def.fields).flat())].filter((c) => !have.has(c));
}
// ---------------------------------------------------------------- value cleaning
const UAE_BOUNDS = { minLat: 22, maxLat: 27, minLng: 51, maxLng: 57 };
/** "25.2626, 55.3286", "25.2626 55.3286" or a Google Maps link → pin; null if none or outside the UAE. */
function parsePin(text) {
    if (!text)
        return null;
    const m = /@(-?\d{1,3}\.\d+),\s*(-?\d{1,3}\.\d+)/.exec(text) ??
        /[?&](?:q|query|ll)=(-?\d{1,3}\.\d+),\s*(-?\d{1,3}\.\d+)/.exec(text) ??
        /^\s*(-?\d{1,3}\.\d+)\s*[, ]\s*(-?\d{1,3}\.\d+)\s*$/.exec(text);
    if (!m)
        return null;
    return pinInUae(Number(m[1]), Number(m[2]));
}
function pinInUae(latitude, longitude) {
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude))
        return null;
    const inside = latitude >= UAE_BOUNDS.minLat && latitude <= UAE_BOUNDS.maxLat && longitude >= UAE_BOUNDS.minLng && longitude <= UAE_BOUNDS.maxLng;
    return inside ? { latitude, longitude } : null;
}
/** "AED 1,204.5" → 120450 fils; rounds to whole fils; null when not a number. */
function parseMoneyToFils(text) {
    const s = text.replace(/aed|dhs?|,|\s/gi, '');
    if (s === '' || s === '-')
        return 0;
    if (!/^-?\d+(\.\d+)?$/.test(s))
        return null;
    return Math.round(Number(s) * 100);
}
// ---------------------------------------------------------------- row checks
exports.PROBLEM_TEXT = {
    // errors: row is not imported (plan 4.2 validation)
    MISSING_AWB: 'AWB number is missing',
    DUPLICATE_AWB_IN_FILE: 'Same AWB appears more than once in this file',
    DUPLICATE_AWB: 'AWB already exists in Blink Ops',
    MISSING_PHONE: 'Mobile number is missing',
    INVALID_PHONE: 'Not a UAE mobile number',
    PLACEHOLDER_PHONE: 'Placeholder mobile number (e.g. 0500000000)',
    INVALID_COD: 'COD amount is not a valid number',
    INVALID_PIECES: 'Pieces must be a whole number from 1 to 99',
    MISSING_MERCHANT: 'Merchant name is missing',
    // warnings: row is imported and flagged
    UNKNOWN_DISTRICT: 'District not recognised — imported; fix it in Addresses to fix',
    NEW_MERCHANT: 'New merchant — added to the project when imported',
    NAME_MISSING: 'Customer name is missing',
    ALT_PHONE_INVALID: 'Alternate number is not a UAE mobile and was left out',
    PIN_INVALID: 'Pin is not valid or outside the UAE and was left out',
    WEIGHT_INVALID: 'Weight is not a number and was left out',
    NO_PIN: 'No pin: location comes from the district only',
    OTHER_HUB: 'District belongs to another hub (hub transfer needed)',
    SAVED_PLACE_SUGGESTED: 'Customer has a saved place, but the name or district differs — dispatcher decides',
    // skipped: not imported, not an error
    NOT_OPEN: 'Client status is not open — skipped',
};
/** Applies a layout to one row and runs every check that needs no database. */
function parseRow(raw, def) {
    const get = (key) => {
        const value = (def.fields[key] ?? [])
            .slice(0, canMerge(key) ? undefined : 1)
            .map((c) => (raw[c] ?? '').toString().trim())
            .filter(Boolean)
            .join(', ');
        return value === '' ? null : value;
    };
    const errors = [];
    const warnings = [];
    const awb = get('awb')?.replace(/\s+/g, '').toUpperCase() ?? null;
    if (!awb)
        errors.push({ code: 'MISSING_AWB', field: 'awb' });
    const merchantName = get('merchant');
    if (def.fields.merchant?.length && !merchantName)
        errors.push({ code: 'MISSING_MERCHANT', field: 'merchant' });
    const name = get('consigneeName');
    if (!name)
        warnings.push({ code: 'NAME_MISSING', field: 'consigneeName' });
    const phoneRaw = get('phone');
    let phone = null;
    if (!phoneRaw)
        errors.push({ code: 'MISSING_PHONE', field: 'phone' });
    else {
        phone = (0, phone_1.normalizeUaeMobile)(phoneRaw);
        if (!phone)
            errors.push({ code: 'INVALID_PHONE', field: 'phone' });
        else if ((0, phone_1.isPlaceholderPhone)(phone))
            errors.push({ code: 'PLACEHOLDER_PHONE', field: 'phone' });
    }
    const altRaw = get('altPhone');
    let altPhone = null;
    if (altRaw) {
        altPhone = (0, phone_1.normalizeUaeMobile)(altRaw);
        if (!altPhone || (0, phone_1.isPlaceholderPhone)(altPhone) || altPhone === phone) {
            if (!altPhone || (0, phone_1.isPlaceholderPhone)(altPhone))
                warnings.push({ code: 'ALT_PHONE_INVALID', field: 'altPhone' });
            altPhone = null;
        }
    }
    let pin = null;
    const lat = get('latitude');
    const lng = get('longitude');
    const pinText = get('pin');
    if (lat && lng) {
        pin = pinInUae(Number(lat), Number(lng));
        if (!pin)
            warnings.push({ code: 'PIN_INVALID', field: 'latitude' });
    }
    else if (pinText) {
        pin = parsePin(pinText);
        if (!pin)
            warnings.push({ code: 'PIN_INVALID', field: 'pin' });
    }
    const codText = get('cod');
    let codFils = 0;
    if (codText) {
        const v = parseMoneyToFils(codText);
        if (v == null || v < 0)
            errors.push({ code: 'INVALID_COD', field: 'cod' });
        else
            codFils = v;
    }
    const piecesText = get('pieces');
    let pieces = 1;
    if (piecesText) {
        const n = Number(piecesText);
        if (!Number.isInteger(n) || n < 1 || n > 99)
            errors.push({ code: 'INVALID_PIECES', field: 'pieces' });
        else
            pieces = n;
    }
    const weightText = get('weight');
    let weightGrams = null;
    if (weightText) {
        const w = Number(weightText.replace(/kgs?|g|\s/gi, ''));
        if (!Number.isFinite(w) || w < 0)
            warnings.push({ code: 'WEIGHT_INVALID', field: 'weight' });
        else
            weightGrams = Math.round(def.weightUnit === 'G' ? w : w * 1000);
    }
    const clientStatus = get('clientStatus');
    let skip = null;
    if (def.statusFilter?.allowed.length) {
        const allowed = def.statusFilter.allowed.map((s) => s.trim().toLowerCase());
        if (!clientStatus || !allowed.includes(clientStatus.trim().toLowerCase()))
            skip = 'NOT_OPEN';
    }
    return {
        parsed: {
            awb,
            merchantReference: get('merchantReference'),
            merchantName,
            consigneeName: name ?? 'Unknown',
            phone,
            phoneRaw,
            altPhone,
            address: get('address'),
            city: get('city'),
            districtText: get('district'),
            latitude: pin?.latitude ?? null,
            longitude: pin?.longitude ?? null,
            codFils,
            pieces,
            weightGrams,
            deliveryType: get('deliveryType'),
            timeSlot: get('timeSlot'),
            description: get('description'),
            clientStatus,
        },
        errors,
        warnings,
        skip,
    };
}
/** Piece labels and barcodes: one piece → the AWB itself; several → AWB-1, AWB-2… labelled 1/3, 2/3… */
/** "TEMU LLC." and "Temu LLC" are the same merchant: case, spaces and punctuation are ignored. */
function merchantKey(name) {
    return name.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}
/** A short unique code for a merchant added from a file: "Shein Middle East" → SHEIN_MIDDLE_EAST. */
function merchantCode(name, taken) {
    const base = (name.toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'MERCHANT').slice(0, 24);
    let code = base;
    for (let i = 2; taken.has(code); i++)
        code = `${base.slice(0, 21)}_${i}`;
    return code;
}
function pieceLabels(awb, count) {
    return Array.from({ length: count }, (_, i) => ({
        sequence: i + 1,
        label: `${i + 1}/${count}`,
        barcode: count === 1 ? awb : `${awb}-${i + 1}`,
    }));
}
//# sourceMappingURL=intake.js.map